import classes from './ProfileSettingsTab.module.scss';
import i18n from '../../../../../utils/i18n';
import { stripHtmlTags } from '../../../../../utils/htmlUtils';
import { useState, useEffect, useContext } from 'react';
import { TextField, Divider } from '@mui/material';
import TextfieldIcon from '../../../../components/TextfieldIcon';
import CustomButton from '../../../../components/CustomButton';
import RichTextEditor from '../../../../../components/RichTextEditor/RichTextEditor';
import ProfileIconUpload from '../../../images/profile-icon-upload.svg';
// import IconTickWhite from '../../../../images/icon-tick-white.svg';
import GeneralBlueTick from '../../../images/general-blue-tick.svg';
import SizeOptionIndividual from '../../../../../images/size-option-individual.svg';
import SizeOptionSmallOffice from '../../../../../images/size-option-small-office.svg';
import SizeOptionOffice from '../../../../../images/size-option-office.svg';
import SizeOptionLargeOffice from '../../../../../images/size-option-large-office.svg';
import CheckboxLanguage from '../../../../components/CheckboxLanguage';
// import IconTrash from '../../../../images/icon-trash.svg';
import ContactEmail from '../../../images/contact-icon-email.svg';
import ContactPhone from '../../../images/contact-icon-phone.svg';
import ContactWeb from '../../../images/contact-icon-web.svg';
import ContactCalendar from '../../../images/contact-icon-calendar.svg';
import ContactFacebook from '../../../images/contact-icon-facebook.svg';
import ContactLinkedIn from '../../../images/contact-icon-linkedin.svg';
import ContactInstagram from '../../../images/contact-icon-instagram.svg';
import LanguageIconHUN from '../../../../../images/LanguageIcons/language-icon-hungarian.svg';
import LanguageIconENG from '../../../../../images/LanguageIcons/language-icon-english.svg';
import LanguageIconGER from '../../../../../images/LanguageIcons/language-icon-german.svg';
import LanguageIconESP from '../../../../../images/LanguageIcons/language-icon-spanish.svg';
import LanguageIconFRA from '../../../../../images/LanguageIcons/language-icon-french.svg';
import LanguageIconROU from '../../../../../images/LanguageIcons/language-icon-romanian.svg';
import LanguageIconCHN from '../../../../../images/LanguageIcons/language-icon-chinese.svg';
import LanguageIconRUS from '../../../../../images/LanguageIcons/language-icon-russian.svg';
import LanguageIconITA from '../../../../../images/LanguageIcons/language-icon-italian.png';
import SelectorOption from '../../../../components/SelectorOption';
import InsuranceInfo from './components/InsuranceInfo';
import ImageUpload from './components/imageUpload';
import MarketingBanner from '../../../../components/MarketingBanner';
import InsuranceLady from '../../../../../images/banner-insurance-lady.svg';
import ProfileIcon from '../../../../../images/size-option-individual.svg';

import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from '../../../../../redux/action';
import InputContext from '../../../../../context/inputContext';

const ProfileSettingsTab = ({
	providerData,
	// fetchProviderData,
	// addProviderInfo,
	// submitToDB,
}) => {
	const dispatch = useDispatch();
	const { isChanged, setIsChanged } = useContext(InputContext);
	const providerID = useSelector((state) => state.providerID || state.userData?.id);
	const handleChange = (event, storeObj) => {
		dispatch(
			ACTIONS.addProviderInfo({
				id: event.target.id,
				data: event.target.value,
				stateObject: storeObj,
			})
		);
	};

	const [selectedLanguages, setSelectedLanguages] = useState(
		providerData.provider_languages
	);

	const profileChecker = {
		companyName: providerData.provider_info.companyname,
		description: stripHtmlTags(providerData.provider_info.description),
		email: providerData.provider_info.email,
		phone: providerData.provider_info.phone,
		packageSize: providerData.provider_package.packageSize,
		noofemployees: providerData.provider_info.noofemployees,
	};

	const valueCheck = (data) => {
		if (typeof data === 'object' && data !== null) {
			const values = Object.values(data);

			return values.every(
				(value) =>
					value !== undefined && value !== null && value !== '' && value !== 0
			);
		}
		return false;
	};

	useEffect(() => {
		if (
			providerData.provider_onboarding.profilesettings_flow?.iscompleted ===
			false
		) {
			if (valueCheck(profileChecker) === true) {
				dispatch(
					ACTIONS.updateNestedObject({
						id: 'iscompleted',
						data: true,
						stateObject: 'provider_onboarding',
						stateObjectID: `profilesettings_flow`,
					})
				);
			}
		} else if (
			providerData.provider_onboarding.profilesettings_flow?.iscompleted ===
			true
		) {
			if (valueCheck(profileChecker) === false) {
				dispatch(
					ACTIONS.updateNestedObject({
						id: 'iscompleted',
						data: false,
						stateObject: 'provider_onboarding',
						stateObjectID: `profilesettings_flow`,
					})
				);
			}
		}
	}, [providerData.provider_info, providerData.provider_package]);

	// useEffect(() => {
	// 	console.log('selectedLanguages', selectedLanguages);
	// 	// console.log('PROVIDER INFO', providerData.provider_info);
	// 	console.log('PROVIDER LANGUAGES', providerData.provider_languages);
	// }, [providerData]);

	const handleLanguageToggle = (id) => {
		console.log('id', id);
		const updatedLanguages = {
			...selectedLanguages,
			[id]: !selectedLanguages[id],
		};

		setSelectedLanguages(updatedLanguages);

		dispatch(
			ACTIONS.addProviderInfo({
				id: id,
				data: updatedLanguages[id],
				stateObject: 'provider_languages',
			})
		);
	};

	const languages = [
		{
			id: 'hungarian',
			imgSrc: LanguageIconHUN,
			languageName: i18n.t('languages.hungarian'),
		},
		{
			id: 'english',
			imgSrc: LanguageIconENG,
			languageName: i18n.t('languages.english'),
		},
		{
			id: 'german',
			imgSrc: LanguageIconGER,
			languageName: i18n.t('languages.german'),
		},
		{
			id: 'french',
			imgSrc: LanguageIconFRA,
			languageName: i18n.t('languages.french'),
		},
		{
			id: 'chinese',
			imgSrc: LanguageIconCHN,
			languageName: i18n.t('languages.chinese'),
		},
		{
			id: 'russian',
			imgSrc: LanguageIconRUS,
			languageName: i18n.t('languages.russian'),
		},
		// {
		// 	id: 'romanian',
		// 	imgSrc: LanguageIconROU,
		// 	languageName: i18n.t('languages.romanian'),
		// },
		{
			id: 'spanish',
			imgSrc: LanguageIconESP,
			languageName: i18n.t('languages.spanish'),
		},
		{
			id: 'italian',
			imgSrc: LanguageIconITA,
			languageName: i18n.t('languages.italian'),
		},
	];

	const handleViewProfile = () => {
		if (providerID) {
			const profileUrl = `${window.location.origin}/provider/${providerID}`;
			window.open(profileUrl, '_blank', 'noopener,noreferrer');
		}
	};

	return (
		<>
			<div style={{ padding: '0 18px' }}>
				<MarketingBanner
					imgSrc={InsuranceLady}
					//title={i18n.t('general.viewprofile')}
					//	subtitle={i18n.t('general.viewprofiltext')}
					imgWidth='75px'
					imgMarginLeft='16px'
					buttonLabel={i18n.t('general.viewcta')}
					onButtonClick={handleViewProfile}
				/>
			</div>
			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('provider.profiledatas')}
					</div>
				</div>

				<div className={classes.rightColumn}>
					<div className={classes.profileImageTitle}>
						{i18n.t('provider.profileimage')}
					</div>
					<div className={classes.profileImageWrapper}>
						<div>
							{/* <img src={ProfileIconDefaultBK} alt='ProfileImage' /> */}
							{/* {profileImage ? (
								<Avatar
									src={profileImage}
									alt='ProfileImage'
									sx={{ width: 120, height: 120 }}
								/>
							) : (
								<Avatar
									src={ProfileIconDefaultBK}
									alt='DefaultProfileImage'
									sx={{ width: 120, height: 120 }}
								/>
							)} */}
							<ImageUpload />
						</div>
						<CustomButton
							buttonName={i18n.t('provider.profileimageupload')}
							iconSrc={ProfileIconUpload}
							buttonColor='#e0e0ff'
							hoverColor='#e0e0ff'
							titleColor='#1c32f3'
							titleHoverColor='#1c32f3'
							width='190px'
							height='44px'
							padding='12px'
							onClick={() =>
								document.getElementById('file-upload-image').click()
							}
						/>
						{/* <CustomButton
							buttonName={i18n.t('general.delete')}
							iconSrc={IconTrash}
							buttonColor='#fafcfe'
							hoverColor='#fafcfe'
							titleColor='#4b5080'
							titleHoverColor='#4b5080'
							width='85px'
							height='44px'
							padding='12px'
							borderColor='#e3e5e9'
							borderWidth='1px'
						/> */}
					</div>

					<div className={classes.companyName}>
						<TextfieldIcon
							label={i18n.t('provider.companyname')}
							iconSrc={SizeOptionLargeOffice}
							placeholder='-'
							id='companyname'
							value={providerData.provider_info.companyname}
							isRequired={true}
							showAsterix={true}
							onChange={(e) => {
								handleChange(e, 'provider_info');
								setIsChanged(true);
							}}
						/>
					</div>

					<label className={classes.introductionLabel}>
						{i18n.t('provider.introduction')}
					</label>
					<RichTextEditor
						value={providerData.provider_info.description}
						onChange={(htmlContent) => {
							// Create a synthetic event to maintain compatibility with existing handleChange
							const syntheticEvent = {
								target: {
									id: 'description',
									value: htmlContent,
								},
							};
							handleChange(syntheticEvent, 'provider_info');
							setIsChanged(true);
						}}
						placeholder={i18n.t('provider.introduction')}
						height='200px'
						showToolbar={true}
					/>
				</div>
			</div>

			<Divider sx={{ margin: '12px 0' }} />

			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('provider.companysize')}
					</div>
				</div>

				<div className={classes.rightColumn}>
					<div className={classes.sizeOptions}>
						<SelectorOption
							label={i18n.t('general.entrepreneur')}
							subLabel={`(1 ${i18n.t('general.person')})`}
							icon={SizeOptionIndividual}
							isSelected={
								providerData.provider_package.packageSize === 'entrepreneur'
							}
							onClick={() => {
								dispatch(
									ACTIONS.addProviderInfo({
										id: 'packageSize',
										data: 'entrepreneur',
										stateObject: 'provider_package',
									})
								);
								setIsChanged(true);
							}}
							borderRadius='8px 0 0 0'
							borderSides={{ top: true, right: true, bottom: true, left: true }}
						/>
						<SelectorOption
							label={i18n.t('general.smalloffice')}
							subLabel={`(2 - 5 ${i18n.t('general.person')})`}
							icon={SizeOptionSmallOffice}
							isSelected={
								providerData.provider_package.packageSize === 'small_office'
							}
							onClick={() => {
								dispatch(
									ACTIONS.addProviderInfo({
										id: 'packageSize',
										data: 'small_office',
										stateObject: 'provider_package',
									})
								);
								setIsChanged(true);
							}}
							borderRadius='0 8px 0 0'
							borderSides={{
								top: true,
								right: true,
								bottom: true,
								left: false,
							}}
						/>
					</div>
					<div className={classes.sizeOptions}>
						<SelectorOption
							label={i18n.t('general.office')}
							subLabel={`(6 - 20 ${i18n.t('general.person')})`}
							icon={SizeOptionOffice}
							isSelected={
								providerData.provider_package.packageSize === 'office'
							}
							onClick={() => {
								dispatch(
									ACTIONS.addProviderInfo({
										id: 'packageSize',
										data: 'office',
										stateObject: 'provider_package',
									})
								);
								setIsChanged(true);
							}}
							borderRadius='0 0 0 8px'
							borderSides={{
								top: false,
								right: true,
								bottom: true,
								left: true,
							}}
						/>
						<SelectorOption
							label={i18n.t('general.corporate')}
							subLabel={`(20+ ${i18n.t('general.person')})`}
							icon={SizeOptionLargeOffice}
							isSelected={
								providerData.provider_package.packageSize === 'corporate'
							}
							onClick={() => {
								dispatch(
									ACTIONS.addProviderInfo({
										id: 'packageSize',
										data: 'corporate',
										stateObject: 'provider_package',
									})
								);
								setIsChanged(true);
							}}
							borderRadius='0 0 8px 0'
							borderSides={{
								top: false,
								right: true,
								bottom: true,
								left: false,
							}}
						/>
					</div>
					<div className={classes.noofemployees}>
						<TextfieldIcon
							label={i18n.t('general.noofemployees')}
							iconSrc={ProfileIcon}
							placeholder='-'
							id='noofemployees'
							value={providerData.provider_info.noofemployees}
							isRequired={true}
							showAsterix={true}
							onChange={(e) => {
								handleChange(e, 'provider_info');
								setIsChanged(true);
							}}
						/>
					</div>
				</div>
			</div>

			<Divider sx={{ margin: '12px 0' }} />

			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('provider.spokenlanguages')}
					</div>
					<div className={classes.profileSubTitle}>
						{i18n.t('provider.spokenlanguagessub')}
					</div>
				</div>
				<div className={classes.rightColumn}>
					{languages.map(({ id, imgSrc, languageName }) => (
						<CheckboxLanguage
							key={id}
							imgSrc={imgSrc}
							languageName={languageName}
							isSelected={selectedLanguages[id]}
							onSelect={() => {
								handleLanguageToggle(id);
								setIsChanged(true);
							}}
						/>
					))}
				</div>
			</div>

			<Divider sx={{ margin: '12px 0' }} />

			<div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<div className={classes.profileTitle}>
						{i18n.t('general.availibility')}
					</div>
				</div>
				<div className={classes.rightColumn}>
					<div className={classes.textfieldIconTop}>
						<TextfieldIcon
							label={i18n.t('general.emailaddress')}
							iconSrc={ContactEmail}
							placeholder='-'
							isRequired={true}
							showAsterix={true}
							id='email'
							value={providerData.provider_info.email}
							onChange={(e) => {
								handleChange(e, 'provider_info');
								setIsChanged(true);
							}}
						/>
					</div>
					<TextfieldIcon
						label={i18n.t('general.phonenumber')}
						iconSrc={ContactPhone}
						placeholder='-'
						isRequired={true}
						showAsterix={true}
						id='phone'
						value={providerData.provider_info.phone}
						onChange={(e) => {
							handleChange(e, 'provider_info');
							setIsChanged(true);
						}}
					/>
					<TextfieldIcon
						label={i18n.t('general.webpage')}
						iconSrc={ContactWeb}
						placeholder='-'
						isRequired={true}
						showAsterix={false}
						id='companywebpage'
						value={providerData.provider_info.companywebpage}
						onChange={(e) => {
							handleChange(e, 'provider_info');
							setIsChanged(true);
						}}
					/>
					<TextfieldIcon
						label={i18n.t('general.contactcalendarlink')}
						iconSrc={ContactCalendar}
						placeholder='-'
						isRequired={true}
						showAsterix={false}
						id='bookinglink'
						value={providerData.provider_info.bookinglink}
						onChange={(e) => {
							handleChange(e, 'provider_info');
							setIsChanged(true);
						}}
					/>
					<TextfieldIcon
						label={i18n.t('general.facebook')}
						iconSrc={ContactFacebook}
						placeholder='-'
						isRequired={true}
						showAsterix={false}
						id='social'
						value={providerData.provider_info.social}
						onChange={(e) => {
							handleChange(e, 'provider_info');
							setIsChanged(true);
						}}
					/>
					<TextfieldIcon
						label={i18n.t('general.linkedin')}
						iconSrc={ContactLinkedIn}
						placeholder='-'
						isRequired={true}
						showAsterix={false}
						id='linkedin'
						value={providerData.provider_info.linkedin}
						onChange={(e) => {
							handleChange(e, 'provider_info');
							setIsChanged(true);
						}}
					/>
					<TextfieldIcon
						label={i18n.t('general.instagram')}
						iconSrc={ContactInstagram}
						placeholder='-'
						isRequired={true}
						showAsterix={false}
						id='insta'
						value={providerData.provider_info.insta}
						onChange={(e) => {
							handleChange(e, 'provider_info');
							setIsChanged(true);
						}}
					/>
				</div>
			</div>

			<Divider sx={{ margin: '12px 0' }} />

			{/* <div className={classes.paragraph}>
				<div className={classes.leftColumn}>
					<p className={classes.profileTitle}>
						{i18n.t('provider.accountdeletion')}
					</p>
					<p className={classes.profileSubTitle}>
						{i18n.t('provider.accountdeletionalert')}
					</p>
				</div>
				<div className={classes.rightColumn}>
					<div className={classes.accountDeletion}>
						<CustomButton
							buttonName={i18n.t('provider.accountdeletion')}
							iconSrc={IconTrash}
							buttonColor='#fafcfe'
							hoverColor='#fafcfe'
							titleColor='#4b5080'
							titleHoverColor='#4b5080'
							width='220px'
							height='44px'
							padding='12px'
							borderColor='#e3e5e9'
							borderWidth='1px'
						/>
					</div>
				</div>
			</div> */}
		</>
	);
};

export default ProfileSettingsTab;
